import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BackBtnWrapper, VideoPlayerWrapper, VideosPageWrapper } from "../components";
import ICONS from "../../../constants/icons";
import { gamesData } from "./gamesData";
import { BarLoader } from "react-spinners";

const ChosenGame = () => {
  const [chosenGame, setChosenGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const { gameId } = useParams();
  useEffect(() => {
    setChosenGame(gamesData.find((item) => item.id === gameId));
  }, [gameId]);

  return (
    <VideosPageWrapper>
      <Link to="/app/belinson/games">
        <BackBtnWrapper style={{ position: "absolute", top: "16px", left: "45px" }}>
          <ICONS.SidebarCloser />
          <div>Back</div>
        </BackBtnWrapper>
      </Link>
      {/* <BelinsonHeader>
        <TitleWrapper>{chosenVid?.title}</TitleWrapper>
      </BelinsonHeader> */}
      <VideoPlayerWrapper>
        {loading ? (
          <BarLoader
            speedMultiplier={0.5}
            cssOverride={{ position: "absolute" }}
            width="90%"
            color="#36d7b7"
          />
        ) : null}

        <iframe
          src={chosenGame?.url}
          frameBorder="0"
          onLoad={() => setLoading(false)}
          width="100%"
          height="100%"
          title={chosenGame?.title}
        />
      </VideoPlayerWrapper>
    </VideosPageWrapper>
  );
};

export default ChosenGame;
